<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>Invoice</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon left to="/administration/invoicing"><v-icon>mdi-arrow-left</v-icon></v-btn>
            </v-toolbar>

            <v-row class="justify-center py-5">
                <v-col cols="8">
                    <v-text-field v-model="searchInv" append-icon="mdi-magnify" dense label="Search" :rules="numberRule"
                        hide-details v-on:keyup.enter="searchInvoice"></v-text-field>
                </v-col>
            </v-row>
            <v-container grid-list-xs fluid>
                <v-row class="dmiRow">
                    <v-col cols="12">
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Invoice ID</th>
                                    <th>Invoice Type</th>
                                    <th>Invoice Date</th>
                                    <th>Customer</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Region</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ headers.InvId }}</td>
                                    <td>{{ headers.InvTypeName }}</td>
                                    <td>{{ headers.InvDate }}</td>
                                    <td>{{ headers.CustomerName }}</td>
                                    <td>{{ headers.StartDate }}</td>
                                    <td>{{ headers.EndDate }}</td>
                                    <td>{{ headers.Region }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-container grid-list-xs fluid>
                        <v-col cols="12">
                            <v-card>
                                <v-simple-table dense height="350px" v-if="headers.InvTypeName == 'Pump Work'">
                                    <template v-slot:top>
                                        <v-container grid-list-xs class="primary" fluid>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-combobox dark v-model="search" dense @change="changeSearch"
                                                        :items="ordersNum" hide-details append-icon="mdi-magnify" class="
                                                                    mx-3
                                                                    mt-5
                                                                " label="Order Look Up">
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-row justify="end">
                                                        <v-btn color="light" class="mt-6 mr-2" @click="
                                                            openModalOrder(
                                                                search
                                                            )
                                                            ">
                                                            View Order
                                                            <v-icon>mdi-eye</v-icon>
                                                        </v-btn>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </template>
                                    <tbody v-for="(itm, i) in transactions" :key="i">
                                        <template v-if="filter(itm)">
                                            <tr>
                                                <th v-for="(itm,
                                                    i) in tableHeaders" :key="i">
                                                    {{ itm.text }}
                                                </th>
                                            </tr>
                                            <tr style="border-top:4px solid #000;">
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.OrderNumber }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.TranType }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.BOL }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.TerminalName }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.StationName }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" v-model="itm.InvId" dense
                                                        hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" v-model="itm.Quantity" @blur="
                                                        CalculateAmount(itm)
                                                        " dense hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" v-model="itm.Rate" @blur="
                                                        CalculateAmount(
                                                            itm
                                                        )
                                                        " dense hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" dense v-model="itm.Amount"
                                                        hide-details></v-text-field>
                                                </td>
                                                <td style="background-color:#ebf3fd;">
                                                    <v-btn color="success" icon @click="
                                                        saveTrnsaction(itm, i)
                                                        "><v-icon>mdi-content-save</v-icon></v-btn>
                                                    <v-btn color="primary" icon
                                                        @click="openRates(itm)"><v-icon>mdi-book-open-blank-variant</v-icon></v-btn>
                                                        <v-btn
                                                        color="red"
                                                        icon
                                                        @click="
                                                            dltTrnsConfirm(itm)
                                                        "
                                                        ><v-icon
                                                            >mdi-delete</v-icon
                                                        ></v-btn
                                                    >
                                                </td>
                                            </tr>
                                            <tr>
                                                <th colspan="1" style="background-color:#ebf3fd;">
                                                    Description
                                                </th>

                                                <td colspan="9" style="background-color:#ebf3fd;">
                                                    <v-text-field v-model="itm.Description" dense hide-details></v-text-field>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </v-simple-table>
                                <v-simple-table dense height="350px" v-else>
                                    <template v-slot:top>
                                        <v-container grid-list-xs class="primary" fluid>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-combobox dark v-model="search" dense @change="changeSearch"
                                                        :items="ordersNum" hide-details append-icon="mdi-magnify" class="
                                                                    mx-3
                                                                    mt-5
                                                                " label="Order Look Up">
                                                    </v-combobox>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-row justify="end">
                                                        <v-btn color="light" class="mt-6 mr-2" @click="
                                                            openModalOrder(
                                                                search
                                                            )
                                                            ">
                                                            View Order
                                                            <v-icon>mdi-eye</v-icon>
                                                        </v-btn>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </template>
                                    <tbody v-for="(itm, i) in transactions" :key="i">
                                        <template v-if="filter(itm)">
                                            <tr>
                                                <th v-for="(itm,
                                                    i) in tableHeaders" :key="i">
                                                    {{ itm.text }}
                                                </th>
                                            </tr>
                                            <tr style="border-top:4px solid #000;">
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.OrderNumber }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.TranType }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.BOL }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.TerminalName }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    {{ itm.StationName }}
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" v-model="itm.InvId" dense
                                                        hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" v-model="itm.Quantity" @blur="
                                                        CalculateAmount(itm)
                                                        " dense hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" v-model="itm.Rate" @blur="
                                                        CalculateAmount(
                                                            itm
                                                        )
                                                        " dense hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-text-field style="width:50px;" dense v-model="itm.Amount"
                                                        hide-details></v-text-field>
                                                </td>
                                                <td :width="itm.width" rowspan="2"
                                                    style="background-color:#ebf3fd;border-top:2px solid #000;">
                                                    <v-btn color="success" icon @click="
                                                        saveTrnsaction(itm, i)
                                                        "><v-icon>mdi-content-save</v-icon></v-btn><br />
                                                    <v-btn color="primary" icon
                                                        @click="openRates(itm)"><v-icon>mdi-book-open-blank-variant</v-icon></v-btn>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th v-for="(itm,
                                                    i) in tableSubHeaders" :key="i" style="background-color:#ebf3fd;">
                                                    {{ itm.text }}
                                                </th>
                                                <th colspan="5" style="background-color:#ebf3fd;">
                                                    Description
                                                </th>
                                            </tr>
                                            <tr>
                                                <td :width="itm.width" style="background-color:#ebf3fd;">
                                                    {{ itm.TStart }}
                                                </td>
                                                <td :width="itm.width" style="background-color:#ebf3fd;">
                                                    {{ itm.TEnd }}
                                                </td>
                                                <td :width="itm.width" style="background-color:#ebf3fd;">
                                                    {{ itm.StStart }}
                                                </td>
                                                <td :width="itm.width" style="background-color:#ebf3fd;">
                                                    {{ itm.StEnd }}
                                                </td>
                                                <td :width="itm.width" colspan="5" style="background-color:#ebf3fd;">
                                                    <v-text-field v-model="itm.Description" hide-details></v-text-field>
                                                </td>
                                                <td style="background-color:#ebf3fd;">
                                                    <v-btn color="red" icon @click="
                                                        dltTrnsConfirm(itm)
                                                        "><v-icon>mdi-delete</v-icon></v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-container>
                </v-row>
                <v-row class="dmiRow">
                    <v-col cols="6">
                        <v-simple-table dense class="dmiTable">
                            <thead>
                                <tr style="text-size: 12px">
                                    <th>Order Total</th>
                                    <th>FSC</th>
                                    <th>FSC Amount</th>
                                    <th>Subtotal</th>
                                    <th colspan="2" v-if="dtaDmr.TVQ == 0">
                                        HST
                                    </th>
                                    <th colspan="2" v-if="dtaDmr.TVQ > 0">
                                        TSP
                                    </th>
                                    <th colspan="2" v-if="dtaDmr.TVQ > 0">
                                        TVQ
                                    </th>
                                    <th>Total</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>$ {{ dtaDmr.OrderTotal }}</td>

                                    <td><v-text-field hide-details v-model="dtaDmr
                                            .FSC
                                        " style="width: 60px" color="primary" dense></v-text-field></td>
                                    <td>{{ dtaDmr.FSCAmount }}</td>
                                    <td>${{ dtaDmr.SubTotal }}</td>
                                    <td>${{ dtaDmr.HST }}</td>
                                    <td><v-text-field hide-details v-model="dtaDmr
                                            .HSTPercent
                                        " style="width: 60px" color="primary" dense></v-text-field></td>
                                    <td v-if="dtaDmr.TVQ > 0">
                                        ${{ dtaDmr.TVQ }}
                                    </td>
                                    <td v-if="dtaDmr.TVQ > 0">
                                        <v-text-field hide-details v-model="dtaDmr
                                                .TVQPercent
                                            " style="width: 80px" color="primary" dense></v-text-field>
                                    </td>
                                    <td>{{ dtaDmr.Total }}</td>
                                    <td><v-icon color="primary" @click="
                                        edtInvoice()
                                        " dense>mdi-content-save</v-icon></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col>
                        <v-btn color="primary " class="mt-3" small height="50px" dark
                            @click="calculateInvoice">Calculate<br />Totals</v-btn>
                        <v-btn color="red" class="ml-4 mt-3" small height="50px" dark
                            @click="dltInoviceConfirm"><v-icon>mdi-delete</v-icon> Delete</v-btn>
                    </v-col>
                    <v-col>
                        <v-form ref="formDmr" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col>
                                    <v-combobox v-model="cbxPdf" :items="cbxItms" :item-text="'text'" :item-value="'data'"
                                        label="PDF Options" auto-select-first required @change="selectPDF"
                                        :rules="[v => !!v || 'Required']"></v-combobox>
                                </v-col>
                                <v-btn color="primary" class="mr-2 mt-10" x-small dark @click="pdfs">Download</v-btn>
                                
                                <v-col>
                                    <v-combobox v-model="cbxType
                                        " :items="cbxInvoice
                                            " :item-text="'text'
                                            " :item-value="'id'
                                            " :append-outer-icon="'mdi-plus-box'"
                                        @click:append-outer="createInvoice"
                                        label="Seleccione Type Invoice" auto-select-first
                                        required :rules="[
                                            v =>
                                                !!v ||
                                                'Required'
                                        ]"></v-combobox>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>

        <v-dialog v-model="$store.state.posting.dialog" transition="dialog-bottom-transition" overlay-color="accent"
            width="1500">
            <OrderData :isModal="true" v-if="$store.state.posting.dialog" />
        </v-dialog>
        <v-dialog v-model="$store.state.transacting.dialogRate" persistent :overlay="false" width="1300px"
            transition="dialog-transition">
            <ratesModal :dataInfo="rateInfo" v-if="$store.state.transacting.dialogRate"></ratesModal>
        </v-dialog>
        <CreateM v-if="openDialog" :ordersNum="ordersNum" :InvId="headers" :searchInv="searchInv" :cbxType="cbxType" :openDialog="openDialog" @search="searchInv = $event" @closeModal="openDialog = false;" @close="closeCD"></CreateM>
    </v-container>
</template>
<script>
import ratesModal from '../Modals/Administration/Transacting/RatesModal.vue';
import OrderData from './../Modals/Administration/OrderData.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import CreateM from './../Modals/Administration/Invoice/CreateInvoice.vue';
import moment from 'moment';
import axios from 'axios';
export default {
    components: {
        ratesModal,
        OrderData,
        ConfirmDialogue,
        CreateM
    },
    data: function () {
        return {
            order: [],
            ordersNum: [],
            valid: false,
            InvId: '',
            dlPrms: [],
            search: '',
            dtaDmr: {},
            cbxType:[],
            cbxInvoice: [
                {
                    text: 'Credit',
                    id: 4
                },
                {
                    text: 'Debit',
                    id: 6
                },
            ],
            openDialog:false,
            numberRule: [
                v =>
                    (!isNaN(parseFloat(v)) && v >= 0) ||
                    'Only numbers are allowed'
            ],
            headers: [],
            cbxPdf: [],
            searchInv: null,
            transactions: [],
            cbxItms: [
                {
                    text: 'Print Invoice',
                    data: {
                        name: 'Invoice',
                        Type: 'pdf',
                        Id: 1
                    }
                },
                {
                    text: 'Print Invoice 2012',
                    data: {
                        name: 'Invoice 2012',
                        Type: 'pdf',
                        Id: 3
                    }
                },
                {
                    text: 'Print Invoice UF',
                    data: {
                        name: 'Invoice UF',
                        Type: 'pdf',
                        Id: 4
                    }
                },
                {
                    text: 'Print Invoice ULC',
                    data: {
                        name: 'Invoice ULC',
                        Type: 'pdf',
                        Id: 2
                    }
                },
                {
                    text: 'Print Invoice UF Logistics',
                    data: {
                        name: 'Invoice UFL',
                        Type: 'pdf',
                        Id: 6
                    }
                }
                /*
                {
                    text: 'Save as Excel',
                    data: {
                        name: 'Invoice.xlsx',
                        Type: 'xls',
                        Id: 1
                    }
                }*/
            ],

            tableHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '15%' },
                { text: 'Txn Type', value: 'TranType', width: '10%' },
                { text: 'BOL', value: 'BOL', width: '15%' },
                { text: 'Terminal', value: 'TerminalName', width: '10%' },
                { text: 'Station', value: 'StationName', width: '10%' },

                { text: 'InvId', value: 'InvId', width: '1%' },
                { text: 'Qty', value: 'Quantity', width: '4%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '5%' },
                { text: 'Actions', value: 'delete', width: '1%' }
            ],
            tableSubHeaders: [
                { text: 'Term Start', value: 'TStart', width: '3%' },
                { text: 'Term End', value: 'TEnd', width: '3%' },

                { text: 'Stn Start', value: 'StStart', width: '3%' },
                { text: 'Stn End', value: 'StEnd', width: '3%' }
            ]
        };
    },
    watch: {
        '$store.state.demurrage.watch': function () {
            if (this.$store.state.demurrage.watch == true) {
                this.loadDemurrage();
                this.$store.state.demurrage.watch = false;
            }
        }
    },
    computed: {},
    methods: {
        closeCD: function(){
            this.searchInvoice();
        },
        createInvoice: function () {
            this.openDialog = true;
        },
        CalculateAmount: function (itm) {
            if(itm.TranTypeId == 7 || itm.TranTypeId == 8 || itm.TranTypeId == 12){
                let amount = (itm.Quantity * itm.Rate);
                itm.Amount = Number(amount.toFixed(2));
            }else{
                let amount = ((itm.Quantity * itm.Rate) / 1000);
                itm.Amount = Number(amount.toFixed(2));
            }
        },
        openModalOrder: function (item) {
            if (item != '') {
                this.$store.state.orderInfo.orderId = item;
                this.$store.state.posting.dialog = true;
            }
        },
        filter(itm) {
            return (
                itm.OrderNumber.toString()
                    .toLocaleLowerCase()
                    .indexOf(this.search) > -1
            );
        },
        edtInvoice: function () {
            this.$store.state.isLoading = true;
            var parms = {
                FSC: this.dtaDmr.FSC,
                HSTPercent: this.dtaDmr.HSTPercent,
                TVQPercent: this.dtaDmr.TVQPercent
            };
            console.log(this.dtaDmr);
            axios
                .put('invoice/' + this.$store.state.invoiceLoadId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        selectPDF: function () {
            this.cbxPdf.data.InvId = this.$store.state.invoiceLoadId;
        },
        openRates: function (itm) {
            console.log(itm);
            this.rateInfo = itm;
            this.$store.state.transacting.dialogRate = true;
        },
        saveTrnsaction: function (itm, index) {
            var str = this.$store;
            var params = {
                Quantity: itm.Quantity,
                Rate: itm.Rate,
                Amount: itm.Amount,
                InvId: itm.InvId,
                Description: itm.Description
            };
            axios
                .put('transaction/' + itm.TranId, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    if (this.headers.InvId == itm.InvId) {
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Save successfully'
                        });
                        this.calculateInvoice();
                    } else {
                        this.transactions.splice(index, 1);
                        this.ordersNum = [];
                        this.search = '';
                        this.loadDemurrage();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },

        deleteTrnsaction: function (itm) {
            var str = this.$store;
            axios
                .delete('transaction/removeInv/' + itm, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete transaction successful.'
                    });
                    this.$store.state.demurrage.watch = true;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        changeSearch: function () {
            if (this.search == null) {
                this.search = '';
            }
        },
        deleteInvoice: function () {
            var str = this.$store;
            axios
                .delete('invoice/' + this.$store.state.invoiceLoadId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete Invoice successful.'
                    });
                    this.$router.push('/administration/invoicing');
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        async dltTrnsConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this transaction',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteTrnsaction(itm.TranId);
            }
        },
        async dltInoviceConfirm() {
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You are about to delete invoice #' +
                    this.$store.state.invoiceLoadId,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteInvoice();
            }
        },
        searchInvoice: async function () {
            this.$store.state.isLoading = true;
            let str = this.$store;
            if (this.searchInv == '') {
                this.$store.state.isLoading = false;
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Invoice number needed'
                });
            } else {
                try {
                    let response = await axios.get(
                        'invoice/' + this.searchInv,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    );
                    let type = response.data[0].InvType;
                    console.log(type);
                    if (type == 'Regular Invoice' || type == 'Extra Charges' || type == 'Credit Invoice') {
                        this.$store.state.invoiceLoadId = this.searchInv;
                        this.$router.push('/administration/view-invoiceadm');
                    } else {
                        this.$store.state.invoiceLoadId = this.searchInv;
                        this.loadDemurrage();
                    }
                } catch (error) {
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Invoice not found'
                        });
                        this.searchInv = '';
                    }
                }
                this.$store.state.isLoading = false;
            }
        },
        loadDemurrage: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('invoice/dmg/' + this.$store.state.invoiceLoadId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.dtaDmr = response.data[0];
                    this.transactions = this.dtaDmr.transactions;
                    this.dtaDmr.FSC = Number(this.dtaDmr.FSC).toFixed(2);
                    this.dtaDmr.FSCAmount = Number(this.dtaDmr.FSCAmount).toFixed(2);
                    this.dtaDmr.SubTotal = Number(this.dtaDmr.SubTotal).toFixed(2);
                    this.dtaDmr.HSTPercent = Number(this.dtaDmr.HSTPercent).toFixed(2);
                    this.dtaDmr.HST = Number(this.dtaDmr.HST).toFixed(2);
                    this.dtaDmr.Total = Number(this.dtaDmr.Total).toFixed(2);
                    const data = this.transactions.map(function (t) {
                        return t.OrderNumber;
                    });

                    this.ordersNum = data.reduce((acc, item) => {
                        if (!acc.includes(item)) {
                            acc.push(item);
                        }
                        return acc;
                    }, []);

                    console.log(this.ordersNum);
                    this.headers = {
                        InvId: this.dtaDmr.InvId,
                        InvTypeName: this.dtaDmr.InvTypeName,
                        InvDate: this.dtaDmr.InvDate,
                        CustomerName: this.dtaDmr.CustomerName,
                        StartDate: this.dtaDmr.StartDate,
                        EndDate: this.dtaDmr.EndDate,
                        CustomerID: this.dtaDmr.CustomerID,
                        InvoiceGrp: this.dtaDmr.InvoiceGrp,
                        Region: this.dtaDmr.Region,
                        HSTPercent: this.dtaDmr.HSTPercent,
                        TVQPercent: this.dtaDmr.TVQPercent,
                        FSC: this.dtaDmr.FSC,
                    };
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                });

            str.state.isLoading = false;
        },
        pdfs: function () {
            var parms = {
                Id: this.cbxPdf.data.Id,
                InvId: parseInt(this.$store.state.invoiceLoadId)
            };
            console.log(parms);
            var str = this.$store;

            str.state.isLoading = true;
            axios
                .post('invoice/print/pdf', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.$store.state.invoiceLoadId + ' - ' + moment(this.headers.InvDate).format('ll') + ".pdf");
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });

            str.state.isLoading = true;
        },
        calculateInvoice: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('invoice/calculate/' + this.$store.state.invoiceLoadId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.dtaDmr = response.data;
                    console.log(response.data);
                    this.dtaDmr.FSC = Number(this.dtaDmr.FSC).toFixed(2);

                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Recalculate successful'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        }
    },
    mounted() {
        this.loadDemurrage();
    }
};
</script>
<style scoped>
.dmiTable td {
    border-left: 1px solid #fff;
    background: #eee;
}

.dmiRow {
    background: #ebf3fd;
}
</style>
